export default function suggestedResult() {
    return {
        scope: true,
        replace: true,
        restrict: 'EA',
        template: 
            `<li data-type="{{ ::result.resultType }}">
               <img ng-if="result.imageUrl" ng-src="{{ ::result.imageUrl }}" class="float-left mr-3" style="width:100px" />
               <div>
                   <a ng-href="{{ ::result.url }}" class="search-result-link">
                       <h5 ng-bind="::result.name"></h5>
                   </a>
                   <p ng-bind="::result.description"></p>
                </div>
            </li>`
    };
}